import ActivitySlotsModal from './activitySlotsModal/ActivitySlotsModal';
import { useState } from 'react';
import EditIcon from '../../../assets/icons/trvto_edit_icon.svg';
import DeleteIcon from '../../../assets/icons/trvto_deleteIcon.svg';
import { standardDate } from '../../../utils/formatDate';
import ConfirmationModal from '../../tripStrap/tripStrapFun/cancelBooking';
import { supDeleteActivityDate, supTripOrgDateFun } from '../../../api/supportAdmin';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { getTypeOrg } from '../../../utils/getType';
import { orgActDates, orgDeleteActivityDate } from '../../../api/orgActAPI';
import { orgDeleteGuideDate, orgGuideDates } from '../../../api/orgGuidAPI';

export default function ActivityDates({ dates = [], setDates, upComing, data, type, isOrg }) {
    const [selectedDate, setSelectedDate] = useState(null);
    const [dateToDelete, setDateToDelete] = useState(null);
    const finalType = getTypeOrg(type);
    const getSlotSummary = (slots = []) => {
        return slots.reduce(
            (acc, slot) => {
                acc.capacity += Number(slot.totalSlots || 0);
                acc.booked += Number(slot.bookedSlots || 0);
                acc.available += Number(slot.availableSlots || 0);

                return acc;
            },
            {
                capacity: 0,
                booked: 0,
                available: 0
            }
        );
    };

    const deleteDate = async () => {
        try {
            let response;
            if (isOrg) {
                response =
                    type === 'a'
                        ? await orgDeleteActivityDate(dateToDelete._id)
                        : await orgDeleteGuideDate(dateToDelete._id);
            } else {
                response = await supDeleteActivityDate(dateToDelete._id, finalType);
            }

            if (response.status === 200) {
                toast.success('Date deleted successfully');
                setDateToDelete(null);

                let dateData;
                if (isOrg) {
                    dateData =
                        type === 'a' ? await orgActDates(data._id, 'next') : await orgGuideDates(data._id, 'next');
                } else {
                    dateData = await supTripOrgDateFun(data._id, finalType, 'next');
                }

                setDates(dateData.data.data);
            }
        } catch (err) {
            errorHandle(err);
        }
    };

    return (
        <>
            <table className='orgDatesTabTable'>
                <thead className='orgDatesTabHead'>
                    <tr>
                        <th>Start Date</th>
                        <th>Slots</th>
                        <th>Capacity</th>
                        <th>Booked</th>
                        <th>Available</th>
                        {upComing && <th>Action</th>}
                    </tr>
                </thead>

                <tbody>
                    {dates.map((row) => {
                        const summary = getSlotSummary(row.slots);

                        return (
                            <tr key={row._id} className='orgDatesTabRow'>
                                <td>{standardDate(row?.date?.split('T')[0]) || 'N/A'}</td>

                                <td>{row.slots?.length || 0}</td>

                                <td>{summary.capacity}</td>

                                <td>{summary.booked}</td>

                                <td>{summary.available}</td>

                                {upComing && (
                                    <td>
                                        <button
                                            type='button'
                                            className='deleteBtn'
                                            onClick={() => setSelectedDate(row)}
                                        >
                                            <img src={EditIcon} alt='Edit slots' />
                                        </button>
                                        {summary.booked === 0 && (
                                            <button className='deleteBtn' onClick={() => setDateToDelete(row)}>
                                                <img src={DeleteIcon} alt='trvto_delete' />
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {selectedDate && (
                <ActivitySlotsModal
                    activityDate={selectedDate}
                    onClose={() => setSelectedDate(null)}
                    onDateUpdated={(updatedDate) => {
                        setDates((prev) => prev.map((item) => (item._id === updatedDate._id ? updatedDate : item)));

                        setSelectedDate(updatedDate);
                    }}
                    data={data}
                    type={finalType}
                    isOrg={isOrg}
                />
            )}
            {dateToDelete && (
                <ConfirmationModal
                    setShowModal={setDateToDelete}
                    handleConfirm={deleteDate}
                    message={'Are you sure you want to delete the date?'}
                />
            )}
        </>
    );
}
